export default {
  mounted() {
    window.addEventListener("phx:focus_search", (e) => {
      document.getElementById("user_id_select-ts-control").focus();
    })
  }
}
